<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">PaxelRecycle - Banner</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Nama Banner"
            label-class="control-label"
            class="required"
            label-for="nama-banner"
          >
            <input
              v-model="item.name"
              v-validate="'required'"
              name="nama_banner"
              data-vv-as="Nama Banner"
              id="nama-banner"
              class="form-control"
              placeholder="Nama Banner"
            />
            <b-form-invalid-feedback id="input-nama_banner-feedback">{{
              veeErrors.first("nama_banner")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Banner (Desktop)"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.png/.jpg)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(1920px x 700px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileDesktopJpg"
                  name="imagedesktopjpg"
                  data-vv-as="Gambar Desktop JPG/PNG"
                  v-validate="
                    !item.image_desktop_jpg
                      ? 'required|minimalDimensions:1920,700|ratiolDimensions:1920,700|size:2000|ext:jpg,png,gif,jpeg'
                      : 'minimalDimensions:1920,700|ratiolDimensions:1920,700|size:2000|ext:jpg,png,gif,jpeg'
                  "
                  style="display: none"
                  v-on:change="onChangeFileDesktopJpg()"
                />
                <b-button
                  @click="$refs.fileDesktopJpg.click()"
                  v-show="!item.image_desktop_jpg && !fileDesktopJpg"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_desktop_jpg || fileDesktopJpg"
                  variant="primary"
                  @click="modalDesktopJpg = !modalDesktopJpg"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileDesktopJpg.click()"
                  v-show="item.image_desktop_jpg || fileDesktopJpg"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagedesktopjpg") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Banner (Mobile)"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.png/.jpg)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(640px x 600px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileMobileJpg"
                  name="imagemobilejpg"
                  data-vv-as="Gambar Mobile JPG/PNG"
                  v-validate="
                    !item.image_mobile_jpg
                      ? 'required|minimalDimensions:640,600|ratiolDimensions:640,600|size:2000|ext:jpg,png,gif,jpeg'
                      : 'minimalDimensions:640,600|ratiolDimensions:640,600|size:2000|ext:jpg,png,gif,jpeg'
                  "
                  style="display: none"
                  v-on:change="onChangeFileMobileJpg()"
                />
                <b-button
                  @click="$refs.fileMobileJpg.click()"
                  v-show="!item.image_mobile_jpg && !fileMobileJpg"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_mobile_jpg || fileMobileJpg"
                  variant="primary"
                  @click="modalMobileJpg = !modalMobileJpg"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileMobileJpg.click()"
                  v-show="item.image_mobile_jpg || fileMobileJpg"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagemobilejpg") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Banner (Desktop Webp)"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.webp)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(1920px x 700px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileDesktopWebp"
                  name="imagedesktopwebp"
                  data-vv-as="Gambar Desktop Webp"
                  v-validate="
                    !item.image_desktop_jpg
                      ? 'required|minimalDimensions:1920,700|ratiolDimensions:1920,700|size:2000|ext:webp'
                      : 'minimalDimensions:1920,700|ratiolDimensions:1920,700|size:2000|ext:webp'
                  "
                  style="display: none"
                  v-on:change="onChangeFileDesktopWebp()"
                />
                <b-button
                  @click="$refs.fileDesktopWebp.click()"
                  v-show="!item.image_desktop_webp && !fileDesktopWebp"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_desktop_webp || fileDesktopWebp"
                  variant="primary"
                  @click="modalDesktopWebp = !modalDesktopWebp"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileDesktopWebp.click()"
                  v-show="item.image_desktop_webp || fileDesktopWebp"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagedesktopwebp") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Banner (Mobile Webp)"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.webp)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(640px x 600px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileMobileWebp"
                  name="imagemobilewebp"
                  data-vv-as="Gambar Mobile Webp"
                  v-validate="
                    !item.image_mobile_jpg
                      ? 'required|minimalDimensions:640,600|ratiolDimensions:640,600|size:2000|ext:webp'
                      : 'minimalDimensions:640,600|ratiolDimensions:640,600|size:2000|ext:webp'
                  "
                  style="display: none"
                  v-on:change="onChangeFileMobileWebp()"
                />
                <b-button
                  @click="$refs.fileMobileWebp.click()"
                  v-show="!item.image_mobile_webp && !fileMobileWebp"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_mobile_webp || fileMobileWebp"
                  variant="primary"
                  @click="modalMobileWebp = !modalMobileWebp"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileMobileWebp.click()"
                  v-show="item.image_mobile_webp || fileMobileWebp"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagemobilewebp") }}
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Image Alt Text"
            label-class="control-label"
            class="required"
            label-for="image-alt-text"
          >
            <input
              v-model="item.image_alt"
              v-validate="'required'"
              name="image_alt_Text"
              data-vv-as="Image Alt Text"
              id="image-alt-text"
              class="form-control"
              placeholder="Image Alt Text"
            />
            <b-form-invalid-feedback id="input-image_alt_Text-feedback">{{
              veeErrors.first("image_alt_Text")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="heading-id"
          >
            <input
              v-model="item.heading.id"
              v-validate="'required'"
              name="heading_id"
              data-vv-as="Heading Bahasa"
              id="heading-id"
              class="form-control"
              placeholder="Heading in Bahasa"
            />
            <b-form-invalid-feedback id="input-heading_id-feedback">{{
              veeErrors.first("heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (English)"
            label-class="control-label"
            class="required"
            label-for="heading-en"
          >
            <input
              v-model="item.heading.en"
              v-validate="'required'"
              name="heading_en"
              data-vv-as="Heading English"
              id="heading-en"
              class="form-control"
              placeholder="Heading in English"
            />
            <b-form-invalid-feedback id="input-heading_en-feedback">{{
              veeErrors.first("heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="sub-heading-id"
          >
            <input
              v-model="item.sub_heading.id"
              v-validate="'required'"
              name="sub_heading_id"
              data-vv-as="Sub Heading Bahasa"
              id="sub-heading-id"
              class="form-control"
              placeholder="Sub Heading in Bahasa"
            />
            <b-form-invalid-feedback id="input-sub_heading_id-feedback">{{
              veeErrors.first("sub_heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (English)"
            label-class="control-label"
            class="required"
            label-for="sub-heading-en"
          >
            <input
              v-model="item.sub_heading.en"
              v-validate="'required'"
              name="sub_heading_en"
              data-vv-as="Sub Heading English"
              id="sub-heading-en"
              class="form-control"
              placeholder="Sub Heading in English"
            />
            <b-form-invalid-feedback id="input-sub_heading_en-feedback">{{
              veeErrors.first("sub_heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Dengan Tombol"
            label-for="input-1"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="item.is_with_button"
              :options="optionsWithButton"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="item.is_with_button">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="item.is_with_button ? 'required' : ''"
              v-model="item.button_text.id"
              name="button_text_id"
              data-vv-as="Teks Tombol Bahasa"
              class="form-control"
              placeholder="Teks Tombol in Bahasa"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="item.is_with_button ? 'required' : ''"
              v-model="item.button_text.en"
              name="button_text_en"
              data-vv-as="Teks Tombol English"
              class="form-control"
              placeholder="Teks Tombol English"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_en") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="item.is_with_button">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL Tombol Desktop"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="
                item.is_with_button
                  ? 'required|url: {require_protocol: true }'
                  : ''
              "
              v-model="item.button_url"
              name="button_url"
              data-vv-as="URL Tombol Desktop"
              class="form-control"
              placeholder="Masukkan URL"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_url") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-row v-show="item.is_with_button">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL Tombol Mobile"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="
                item.is_with_button
                  ? 'required|url: {require_protocol: true }'
                  : ''
              "
              v-model="item.button_url_mobile"
              name="button_url_mobile"
              data-vv-as="URL Tombol Mobile"
              class="form-control"
              placeholder="Masukkan URL"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_url_mobile") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PaxelRecycleBanner' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Batal</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="col-2"
            size="lg"
          >
            Simpan
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalDesktopJpg" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktopJpg"
        v-if="item.image_desktop_jpg"
        width
        height="400px"
        :src="item.image_desktop_jpg"
      />
      <img
        v-show="fileDesktopJpg"
        v-if="urlDesktopJpg"
        width
        height="400px"
        :src="urlDesktopJpg"
      />
    </b-modal>
    <b-modal v-model="modalMobileJpg" title="Preview Image" size="xl">
      <img
        v-show="!fileMobileJpg"
        v-if="item.image_mobile_jpg"
        width
        height="400px"
        :src="item.image_mobile_jpg"
      />
      <img
        v-show="fileMobileJpg"
        v-if="urlMobileJpg"
        width
        height="400px"
        :src="urlMobileJpg"
      />
    </b-modal>
    <b-modal v-model="modalDesktopWebp" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktopWebp"
        v-if="item.image_desktop_webp"
        width
        height="400px"
        :src="item.image_desktop_webp"
      />
      <img
        v-show="fileDesktopWebp"
        v-if="urlDesktopWebp"
        width
        height="400px"
        :src="urlDesktopWebp"
      />
    </b-modal>
    <b-modal v-model="modalMobileWebp" title="Preview Image" size="xl">
      <img
        v-show="!fileMobileWebp"
        v-if="item.image_mobile_webp"
        width
        height="400px"
        :src="item.image_mobile_webp"
      />
      <img
        v-show="fileMobileWebp"
        v-if="urlMobileWebp"
        width
        height="400px"
        :src="urlMobileWebp"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        name: "",
        image_desktop_jpg: "",
        image_mobile_jpg: "",
        image_desktop_webp: "",
        image_mobile_webp: "",
        image_alt: "",
        heading: {
          id: "",
          en: ""
        },
        sub_heading: {
          id: "",
          en: ""
        },
        is_with_button: false,
        button_text: {
          id: "",
          en: ""
        },
        button_url: "",
        button_url_mobile: "",
      },
      optionsWithButton: [
        { text: "Tidak", value: false },
        { text: "Ya", value: true },
      ],
      loading: false,
      modalDesktopJpg: false,
      modalMobileJpg: false,
      modalDesktopWebp: false,
      modalMobileWebp: false,
      fileDesktopJpg: "",
      fileMobileJpg: "",
      fileDesktopWebp: "",
      fileMobileWebp: "",
      urlDesktopJpg: "",
      urlMobileJpg: "",
      urlDesktopWebp: "",
      urlMobileWebp: "",
    }
  },
  beforeMount() {
    this.$store
        .dispatch("PaxelRecycleBannerModule/getBanner")
        .then(response => {
          const data = response.data.data
          if(response.data.data) {
            this.item = response.data.data
          } else {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: "Your data could not be fetched",
              showConfirmButton: false,
              timer: 1500
            });  
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Your data data could not be fetched",
            showConfirmButton: false,
            timer: 1500
          });
        });
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("name", this.item.name);
          formData.append("image_desktop_jpg", this.fileDesktopJpg);
          formData.append("image_mobile_jpg", this.fileMobileJpg);
          formData.append("image_desktop_webp", this.fileDesktopWebp);
          formData.append("image_mobile_webp", this.fileMobileWebp);
          formData.append("image_alt", this.item.image_alt);
          formData.append("heading_id", this.item.heading.id);
          formData.append("heading_en", this.item.heading.en);
          formData.append("sub_heading_id", this.item.sub_heading.id);
          formData.append("sub_heading_en", this.item.sub_heading.en);
          formData.append("is_with_button", this.item.is_with_button);
          formData.append("button_text_id", this.item.button_text.id);
          formData.append("button_text_en", this.item.button_text.en);
          formData.append("button_url", this.item.button_url);
          formData.append("button_url_mobile", this.item.button_url_mobile);
          this.$store
            .dispatch("PaxelRecycleBannerModule/postBanner", formData)
            .then((response) => {
              this.loading = false;
              this.$validator.reset();
              // this.$router.push({ name: "PaxelRecycleBanner" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    onChangeFileDesktopJpg() {
      this.fileDesktopJpg = this.$refs.fileDesktopJpg.files[0];
      const input = this.$refs.fileDesktopJpg;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlDesktopJpg = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobileJpg() {
      this.fileMobileJpg = this.$refs.fileMobileJpg.files[0];
      const input = this.$refs.fileMobileJpg;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMobileJpg = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileDesktopWebp() {
      this.fileDesktopWebp = this.$refs.fileDesktopWebp.files[0];
      const input = this.$refs.fileDesktopWebp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlDesktopWebp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobileWebp() {
      this.fileMobileWebp = this.$refs.fileMobileWebp.files[0];
      const input = this.$refs.fileMobileWebp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMobileWebp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>